export default __webpack_public_path__ + "static/media/mail.a6833e38.svg";